import { ListRow, Text } from '@ui'
import React, { PropsWithChildren } from 'react'

/** Key/value row for order and position details. Place inside a `ListGroup`. */
const OrderInfoItem = ({
  attribute,
  children,
}: PropsWithChildren & {
  attribute: string
}) => (
  <ListRow
    dense
    primary={
      <Text as="span" variant="body-s" tone="fg">
        {attribute}
      </Text>
    }
    trailing={
      <Text as="span" variant="body-s" tone="fg-2" tabular className="flex items-center gap-1">
        {children}
      </Text>
    }
  />
)

export default OrderInfoItem
